import { TileRoleRoute } from '@/types'
import { Roles } from '@/auth/azure/Roles'
import { Outlet } from 'react-router-dom'
import { ArgomentoProblemaRoute } from '@/routes/admin/tickets/pages/ArgomentoProblema.route'
import { PiattaformaTicketRoute } from '@/routes/admin/tickets/pages/PiattaformaTicket.route'
import { QSSupportApplicationRoute } from '@/routes/admin/tickets/pages/QSSupportApplication.route'

export const TicketsRoute: TileRoleRoute = {
  path: 'tickets',
  text: 'Tickets',
  element: (
    <>
      <Outlet />
    </>
  ),
  mainMenuRoute: false,
  allowedRoles: [Roles.GlobalAdministrator],
  tile: true,
  children: [QSSupportApplicationRoute, ArgomentoProblemaRoute, PiattaformaTicketRoute],
}
